import Add from './add/CanAddEventInitialState'

const { Record } = require('immutable');

export default Record({
    add: Add()
});